import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select,
} from '@material-ui/core';
import { useField } from 'formik';
import React from 'react';
import { REGISTRATION_ROLE_OPTIONS } from '../../../utils/registrationRoles';

const AvailableRolesSelect = ({
  name = 'configuration.registration.availableRoles',
  disabled = false,
}) => {
  const [field, meta, helpers] = useField(name);
  const selectedRoles = Array.isArray(field.value) ? field.value : [];
  const hasError = meta.touched && Boolean(meta.error);

  const handleChange = (event) => {
    const value = event.target.value;
    helpers.setValue(typeof value === 'string' ? value.split(',') : value);
  };

  return (
    <div className="input__container">
      <FormControl fullWidth error={hasError} disabled={disabled}>
        <Select
          {...field}
          id={name}
          multiple
          displayEmpty
          value={selectedRoles}
          onChange={handleChange}
          onBlur={() => helpers.setTouched(true)}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <span>Selecciona al menos un rol</span>;
            }

            return REGISTRATION_ROLE_OPTIONS.filter(({ value }) =>
              selected.includes(value)
            )
              .map(({ label }) => label)
              .join(', ');
          }}
          inputProps={{
            'aria-label': 'Roles disponibles en el registro',
            'aria-describedby': hasError
              ? `${name}-error-message`
              : undefined,
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
          }}
        >
          {REGISTRATION_ROLE_OPTIONS.map(({ value, label }) => (
            <MenuItem key={value} value={value}>
              <Checkbox
                color="primary"
                checked={selectedRoles.includes(value)}
              />
              <ListItemText primary={label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {hasError && (
        <div id={`${name}-error-message`} className="error-message">
          {meta.error}
        </div>
      )}
    </div>
  );
};

export default AvailableRolesSelect;
